import "core-js/modules/es.array.push.js";
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-34c49532"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "recharge-container"
};
const _hoisted_2 = {
  class: "recharge-card"
};
const _hoisted_3 = {
  class: "card-header"
};
const _hoisted_4 = {
  style: {
    "font-size": "14.5px",
    "font-weight": "600",
    "padding-bottom": "14px"
  }
};
const _hoisted_5 = {
  class: "btn-area"
};
const _hoisted_6 = {
  class: "btn-area"
};
const _hoisted_7 = {
  class: "qrcode-area"
};
const _hoisted_8 = {
  class: "label"
};
const _hoisted_9 = {
  class: "qrcode-str"
};
const _hoisted_10 = {
  class: "recharge-card"
};
const _hoisted_11 = {
  class: "recharge-item"
};
const _hoisted_12 = {
  class: "item-label"
};
const _hoisted_13 = {
  class: "item-value"
};
const _hoisted_14 = {
  class: "recharge-card"
};
const _hoisted_15 = {
  style: {
    "margin-bottom": "10px"
  }
};

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "padding-top": "10px"
  }
}, null, -1));

const _hoisted_17 = ["onClick"];
const _hoisted_18 = {
  class: "title"
};
const _hoisted_19 = {
  class: "sub-title"
};
import { ref, onMounted, onBeforeMount } from 'vue';
import router from '@/router';
import { useRoute } from 'vue-router';
import store from '@/store';
import { Toast } from 'vant';
import 'vant/es/toast/style';
import QrcodeVue from 'qrcode.vue';
import Clipboard from 'clipboard';
import BaseTradeHeader from '@/components/BaseTradeHeader.vue';
import CustomPopupList from '@/components/CustomPopupList.vue';
import { marketInfoRecharge, rechargeUrl, userInfo } from '@/apis';
import { fmtImageSrc } from '@/util';
import { useI18n } from "vue-i18n";
import { fmtNumber } from '@/util';
export default {
  __name: 'RechargeView',

  setup(__props) {
    const {
      t
    } = useI18n();
    const netType = ref(0);
    const netList = ref(['USDT-ERC20', 'USDT-TRC20']);
    const netType1 = ref(0);
    const netList1 = ref(['USDC-ERC20']);
    const coinList = ref([]);
    const coin = ref(null);
    const rechargeCode = ref('');
    const coinShow = ref(false);
    const route = useRoute();
    let type = 'USDT';

    if (route.query.type) {
      type = route.query.type;
    }

    onBeforeMount(() => {// getUserInfoMsg()
    });

    const getUserInfoMsg = () => {
      userInfo({}).then(res => {
        if (res.code === 200 && res.data) {
          if (res.data.authState != 2) {
            router.push({
              name: 'identityAuth'
            });
          }
        }
      });
    };

    onMounted(async () => {
      if (store.state.token === '') {
        router.replace({
          name: 'login'
        });
        return;
      }

      const toast = Toast.loading({
        duration: 0
      });
      const res = await marketInfoRecharge({});

      if (res.code === 200 && res.data) {
        coinList.value = res.data.map(item => {
          const data = {
            id: item.id,
            icon: item.icon,
            name: item.marketName,
            min: item.rechargeMin
          };

          if (item.marketName === type) {
            coin.value = data;
          }

          return data;
        });
      }

      if (coin.value) {
        netInit().finally(() => {
          toast.clear();
        });
      } else {
        toast.clear();
      }
    });

    const netInit = async () => {
      let name = '';
      if (coin.value.name == 'USDT') name = netList.value[netType.value];else if (coin.value.name == 'USDC') name = netList1.value[netType1.value];else name = coin.value.name;
      const result = await rechargeUrl({
        coinType: name
      });

      if (result.code === 200 && result.data) {
        rechargeCode.value = result.data;
      }
    };

    const netChange = index => {
      netType.value = index;
      const toast = Toast.loading({
        duration: 0
      });
      netInit().finally(() => {
        toast.clear();
      });
    };

    const netChange1 = index => {
      netType1.value = index;
      const toast = Toast.loading({
        duration: 0
      });
      netInit().finally(() => {
        toast.clear();
      });
    };

    const getBtnStyle = type => {
      const baseStyle = {
        '--van-button-default-height': '32px',
        '--van-button-normal-font-size': '12px',
        '--van-button-normal-padding': '0 10px',
        'fontWeight': '700',
        'width': '20'
      };

      if (netType.value === type) {
        return { ...baseStyle,
          '--van-button-default-border-color': '#F08504',
          '--van-button-default-color': '#F08504'
        };
      }

      return { ...baseStyle,
        '--van-button-default-background-color': '#F3F3F3',
        '--van-button-default-border-color': '#F3F3F3',
        '--van-button-default-color': 'black'
      };
    };

    const getBtnStyle1 = type => {
      const baseStyle = {
        '--van-button-default-height': '32px',
        '--van-button-normal-font-size': '12px',
        '--van-button-normal-padding': '0 10px',
        'fontWeight': '700',
        'width': '20'
      };

      if (netType1.value === type) {
        return { ...baseStyle,
          '--van-button-default-border-color': '#F08504',
          '--van-button-default-color': '#F08504'
        };
      }

      return { ...baseStyle,
        '--van-button-default-background-color': '#F3F3F3',
        '--van-button-default-border-color': '#F3F3F3',
        '--van-button-default-color': 'black'
      };
    };

    const copyText = () => {
      let copyValue = rechargeCode.value;
      const clipboard = new Clipboard('.copy', {
        text: () => copyValue
      });
      clipboard.on('success', () => {
        Toast({
          message: t('copySuccess'),
          position: 'bottom'
        });
        clipboard.destroy();
      });
      clipboard.on('error', () => {
        Toast({
          message: t('copyError'),
          position: 'bottom'
        });
        clipboard.destroy();
      });
    };

    const coinChange = async index => {
      coinShow.value = false;
      const toast = Toast.loading({
        duration: 0
      });
      coin.value = coinList.value[index];
      netType.value = 0;
      netInit().finally(() => {
        toast.clear();
      });
    };

    return (_ctx, _cache) => {
      const _component_van_button = _resolveComponent("van-button");

      const _component_a_button = _resolveComponent("a-button");

      const _component_van_image = _resolveComponent("van-image");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(BaseTradeHeader, {
        title: _unref(t)('recharge'),
        text: coin.value ? coin.value.name : _unref(t)('selectCurrency'),
        "history-router": "rechargeHistory",
        onCoinShow: _cache[0] || (_cache[0] = $event => coinShow.value = true)
      }, null, 8, ["title", "text"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('rechargeNet')), 1), _withDirectives(_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(netList.value, (item, index) => {
        return _openBlock(), _createBlock(_component_van_button, {
          key: index,
          class: "btn-r",
          style: _normalizeStyle(getBtnStyle(index)),
          onClick: $event => netChange(index)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
          _: 2
        }, 1032, ["style", "onClick"]);
      }), 128))], 512), [[_vShow, coin.value?.name == 'USDT']]), _withDirectives(_createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(netList1.value, (item, index) => {
        return _openBlock(), _createBlock(_component_van_button, {
          key: index,
          class: "btn-r",
          style: _normalizeStyle(getBtnStyle1(index)),
          onClick: $event => netChange1(index)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
          _: 2
        }, 1032, ["style", "onClick"]);
      }), 128))], 512), [[_vShow, coin.value?.name == 'USDC']])]), _createElementVNode("div", _hoisted_7, [_createVNode(QrcodeVue, {
        value: rechargeCode.value,
        size: 130
      }, null, 8, ["value"]), _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('rechargeAddress')), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(rechargeCode.value), 1), _createVNode(_component_a_button, {
        class: "copy",
        type: "link",
        onClick: copyText,
        style: {
          "color": "#F08504"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('copyAddress')), 1)]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('minRecharge')), 1), _createElementVNode("span", _hoisted_13, _toDisplayString(coin.value ? _unref(fmtNumber)(coin.value.min) : '--'), 1)])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)('rechargeTip1')), 1), _createElementVNode("div", null, _toDisplayString(_unref(t)('rechargeTip2')), 1)]), _hoisted_16, _createVNode(CustomPopupList, {
        "c-show": coinShow.value,
        title: _unref(t)('currencyType'),
        onHide: _cache[1] || (_cache[1] = () => {
          coinShow.value = false;
        }),
        position: 'center',
        height: 'auto',
        style: {
          "border-radius": "10px"
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(coinList.value, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "coin-item",
            key: index,
            onClick: $event => coinChange(index)
          }, [_createVNode(_component_van_image, {
            src: _unref(fmtImageSrc)(item.icon),
            width: "25",
            height: "25",
            style: {
              "margin-right": "12px"
            },
            round: ""
          }, null, 8, ["src"]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_18, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_19, _toDisplayString(item.name), 1)])], 8, _hoisted_17);
        }), 128))]),
        _: 1
      }, 8, ["c-show", "title"])]);
    };
  }

};